import { Injectable } from '@angular/core';
import { HttpService } from 'projects/customer/src/app/shared/services/http-service.service';
import { HttpClient } from '@angular/common/http';
import {
    Service,
    Resource,
    DocumentCollection,
    DocumentResource
} from 'ngx-jsonapi';
import { BehaviorSubject, Observable } from 'rxjs';
import { AxiosAuthenticationService } from 'projects/customer/src/app/shared/services/axios-authentication.service';

@Injectable({
    providedIn: 'root'
})
export class PoService {
    private grnSelectedWarehouseSubject = new BehaviorSubject<any>(undefined);
    public grnSelectedWarehouse$ =
        this.grnSelectedWarehouseSubject.asObservable();

    constructor(private http: HttpClient, public httpService: HttpService) {}

    setGrnSelectedWarehouse(warehouseId: any) {
        this.grnSelectedWarehouseSubject.next(warehouseId);
    }

    clearGrnSelectedWarehouse() {
        this.grnSelectedWarehouseSubject.next(undefined);
    }

    getSuppliersList() {
        const path = 'products/supplier';
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    getPriceTags() {
        const path = 'v1/masters/get_price_tag_formats';
        return this.httpService.callAuthGetMasterApi(path);
    }

    getLOSOOSINSProducts(
        type,
        page,
        pageSize,
        searchPatternArr,
        selectedWareHouseId
    ) {
        let path = `products/${type}/product_stock?page[number]=${page}&page[size]=${pageSize}&warehouse_id=${selectedWareHouseId}`;
        if (searchPatternArr.length > 0) {
            searchPatternArr.forEach((pattern, index) => {
                path = path + `&filter[search_pattern][${index}]=` + pattern;
            });
        }
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    getWarehouseList() {
        const path = 'purchase_orders/warehouse';
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    createPO(params) {
        const path = 'purchase_orders/create';
        return this.httpService.callAuthPostApi(path, params, 'jsonApi');
    }

    searchProduct(page, searchFeild, searchBy, warehouse_id?) {
        const path = `orders/available_products?called_from=purchase_orders&page[number]=${page}&filter[${searchBy}][0]=${searchFeild}${
            warehouse_id ? '&filter[warehouse_id][0]=' + warehouse_id : ''
        }`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    getPODetails(poID) {
        const path = `frontend/v1/purchase_orders/${poID}/purchase_order_dtls`;
        return this.httpService.callAuthGetApi(path);
    }

    updatePO(id, data) {
        const path = 'purchase_orders/' + id + '/update';
        return this.httpService.callPutApi(path, data, 'jsonApi');
    }
    addPO(params) {
        const path = 'purchase_orders/create';
        return this.httpService.callAuthPostApi(path, params, 'jsonApi');
    }

    getPOCount() {
        const path = `purchase_orders/counts`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    getPOStatus() {
        const path = `purchase_orders/status`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    addProducts(params) {
        const path = 'purchase_orders/add_product';
        return this.httpService.callAuthPostApi(path, params, 'jsonApi');
    }

    getProductsList(poID, page, pageSize) {
        const path = `purchase_orders/${poID}/product_list?page[number]=${page}&page[size]=${pageSize}`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }

    deleteProduct(id) {
        const path = `purchase_orders/delete_product/${id}`;
        return this.httpService.callPutApi(path, {}, 'jsonApi');
    }

    getProductsTemplateFile() {
        const path = 'v1/masters/templates?type=9';
        return this.httpService.getFileAsBlob(path);
    }

    bulkUploaProductsData(file, formData) {
        const path = 'purchase_orders/bulk_upload_PO_products';
        return this.httpService.callUploadFileServiceApi(
            path,
            file,
            'jsonApi',
            0,
            formData
        );
    }

    cancelPO(po_id, param) {
        const path = `purchase_orders/${po_id}/cancel`;
        return this.httpService.callPutApi(path, param, 'jsonApi');
    }

    editProduct(params, consignment_item_id) {
        const path = `purchase_orders/${consignment_item_id}/update_product_in_po`;
        return this.httpService.callPutApi(path, params, 'jsonApi');
    }

    getInboundSummary(consignment_id) {
        const path = `purchase_orders/${consignment_id}/inbound_summary`;
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }
    downloadReport(id) {
        const path = 'purchase_orders/' + id + '/download_grn_report';
        return this.httpService.getFileAsBlob(path, 'jsonApi');
    }

    grndetails(id) {
        const path = 'purchase_orders/' + id + '/details';
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }
    getconsignment_item_indexList(grnNo, page, pageSize, searchPatternArr?) {
        let path = `purchase_orders/${grnNo}/consignment_item_index?page[number]=${page}&page[size]=${pageSize}`;
        if (searchPatternArr && searchPatternArr.length > 0) {
            searchPatternArr.forEach((pattern, index) => {
                path = path + `&filter[search_pattern][${index}]=` + pattern;
            });
        }
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }
    getGridData(path) {
        return this.httpService.callAuthGetApi(path, 'jsonApi');
    }
}
